// Color de una CLASE, listo para usar en `style`.
//
// 🚨 Trampa (15-ago-2026): en la BD los colores de clase se guardan CON almohadilla
// ('#106AD5', los 60 registros del tenant 227), pero medio front escribía `#${c.color}`
// → '##106AD5', que el navegador descarta en silencio: las clases salían SIN color y
// nadie sabía por qué («¿no tenían color las clases?», Carlos). Los de EVENTO sí van sin
// almohadilla ('4A148C'), así que esto normaliza los dos casos y no hay que recordarlo.
export function colorClase(color?: string | null, fallback = 'rgb(var(--c-blue))') {
  const c = (color ?? '').trim();
  if (!c) return fallback;
  return c.startsWith('#') ? c : `#${c}`;
}

/** El mismo color con transparencia, para tintes de fondo y bordes suaves.
 *  `alfa` va de 0 a 1. Si la clase no tiene color propio, cae al azul de marca. */
export function colorClaseAlfa(color: string | null | undefined, alfa: number) {
  const c = (color ?? '').trim();
  if (!c) return `rgb(var(--c-blue) / ${alfa})`;
  const hex = c.startsWith('#') ? c.slice(1) : c;
  const n = parseInt(hex.length === 3 ? hex.split('').map((x) => x + x).join('') : hex, 16);
  if (isNaN(n)) return `rgb(var(--c-blue) / ${alfa})`;
  return `rgba(${(n >> 16) & 255}, ${(n >> 8) & 255}, ${n & 255}, ${alfa})`;
}
